var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import { CheckboxChecked, CheckboxUnchecked, CheckboxCheckedAlt, CheckboxUncheckedAlt, CheckboxCheckedCeles, CheckboxUncheckedCeles, CheckboxUndeterminedAll, CheckboxUndeterminedSome, } from '../../assets/icons';
import Text from '../Text';
import React, { useCallback, useState } from 'react';
var Checkbox = React.forwardRef(function (props, ref) {
    var className = props.className, _a = props.controlled, controlled = _a === void 0 ? false : _a, defaultState = props.checked, _b = props.disabled, disabled = _b === void 0 ? false : _b, undetermined = props.undetermined, _c = props.variant, variant = _c === void 0 ? 'default' : _c, onChange = props.onChange, label = props.label, onBlur = props.onBlur;
    var _d = useState(defaultState), checked = _d[0], setChecked = _d[1];
    var onCheckedChange = useCallback(function (event) {
        if (!controlled)
            setChecked(event.currentTarget.checked);
        if (onChange)
            onChange(event.currentTarget.checked, event);
    }, [onChange]);
    /* design: 14*14 checkbox */
    var isAlt = variant === 'alt';
    /* design: 18x18 checkbox */
    var isCeles = variant === 'celes';
    /* default: 22x22 checkbox */
    var checkboxCheckedComponent = _jsx(CheckboxChecked, {});
    var checkboxUncheckedComponent = _jsx(CheckboxUnchecked, {});
    if (isAlt) {
        checkboxCheckedComponent = _jsx(CheckboxCheckedAlt, {});
        checkboxUncheckedComponent = _jsx(CheckboxUncheckedAlt, {});
    }
    if (isCeles) {
        checkboxCheckedComponent = _jsx(CheckboxCheckedCeles, {});
        checkboxUncheckedComponent = _jsx(CheckboxUncheckedCeles, {});
    }
    if (undetermined) {
        checkboxCheckedComponent = _jsx(CheckboxUndeterminedAll, {});
        checkboxUncheckedComponent = _jsx(CheckboxUndeterminedSome, {});
    }
    var isAltOrCeles = isAlt || isCeles;
    var isChecked = controlled ? defaultState : checked;
    var text = typeof label === 'string' ? _jsx(Text, __assign({ variant: isAltOrCeles ? 'body2Medium' : 'body2' }, { children: label })) : label;
    return (_jsx(FormControlLabel, { label: text, control: _jsx(MuiCheckbox, { ref: ref, disableRipple: true, className: className, disabled: disabled, onBlur: onBlur, checked: isChecked, onChange: onCheckedChange, icon: checkboxUncheckedComponent, checkedIcon: checkboxCheckedComponent }) }));
});
export default Checkbox;
